<template>
  <footer class="footer">
    <div class="footer-inner">
      <!-- Top row -->
      <div class="footer-top">
        <!-- Brand -->
        <div class="footer-brand">
          <div class="brand-logo">
            <img src="@/assets/logo.png" alt="Logo" />
            <span>DAILK STER</span>
          </div>
          <p class="brand-tagline">
            نحوّل أفكارك إلى تجارب رقمية استثنائية — برمجة وتصميم بمعايير
            عالمية.
          </p>
          <div class="footer-socials">
            <a
              v-for="s in socials"
              :key="s.name"
              :href="s.url"
              target="_blank"
              class="fsocial"
              :title="s.name"
            >
              <span v-html="s.svg" />
            </a>
          </div>
        </div>

        <!-- Links -->
        <div v-for="col in footerLinks" :key="col.title" class="footer-col">
          <h4 class="col-title">{{ col.title }}</h4>
          <ul>
            <li v-for="link in col.links" :key="link.label">
              <a :href="link.href">{{ link.label }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact quick -->
        <div class="footer-col">
          <h4 class="col-title">تواصل سريع</h4>
          <a
            href="https://wa.me/201064665780"
            target="_blank"
            class="footer-wa"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
              />
              <path
                d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.122 1.525 5.858L.057 23.392l5.747-1.504A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.017-1.374l-.36-.213-3.411.893.909-3.318-.234-.375A9.818 9.818 0 0112 2.182c5.428 0 9.818 4.39 9.818 9.818 0 5.429-4.39 9.818-9.818 9.818z"
              />
            </svg>
            واتساب مباشر
          </a>
          <a href="mailto:info@company.com" class="footer-email"
            >thmanahmedthman@gmail.com</a
          >
          <p class="footer-hours">
            متاح: السبت – الخميس<br />9 صباحاً – 11 مساءً
          </p>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="footer-bottom">
        <p>© {{ new Date().getFullYear() }} شركتك. جميع الحقوق محفوظة.</p>
        <div class="bottom-links">
          <a href="#">سياسة الخصوصية</a>
          <a href="#">الشروط والأحكام</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const socials = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/share/1Fmdjwa6Ym/",
    svg: `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/></svg>`,
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/abdo741468?igsh=MXdoMWZsY2IzdWlleA==",
    svg: `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>`,
  },
  {
    name: "Twitter / X",
    url: "https://x.com/ABDOMOMD115027",
    svg: `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>`,
  },
  {
    name: "Telegram",
    url: "https://t.me/+LzZYxt6LXKk1NGJk",
    svg: `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="currentColor"
  viewBox="0 0 24 24"
>
  <path
    d="M9.04 15.47 8.67 20.7c.53 0 .76-.23 1.04-.5l2.5-2.39 5.18 3.79c.95.53 1.63.25 1.89-.88l3.42-16.02h.01c.31-1.45-.52-2.02-1.45-1.67L1.62 10.1c-1.4.55-1.38 1.33-.24 1.68l5.02 1.57L18.07 6c.55-.36 1.05-.16.64.2"
  />
</svg>`,
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@dailkstar?_r=1&_t=ZS-968Ef1KcpbL",
    svg: `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>`,
  },
  {
    name: "YouTube",
    url: "https://youtube.com/channel/UCYacNkePrLBMmwqUL66XXLQ?si=t0_SNBcFVaaPD73r",
    svg: `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>`,
  },
];

const footerLinks = [
  {
    title: "خدماتنا",
    links: [
      { label: "تطوير الويب", href: "#services" },
      { label: "تطبيقات الجوال", href: "#services" },
      { label: "تصميم جرافيك", href: "#services" },
      { label: "متاجر إلكترونية", href: "#services" },
      { label: "تحسين SEO", href: "#services" },
    ],
  },
  {
    title: "الشركة",
    links: [
      { label: "من نحن", href: "#about" },
      { label: "أعمالنا", href: "#portfolio" },
      { label: "الأسعار", href: "#pricing" },
      { label: "اتصل بنا", href: "#contact" },
    ],
  },
];
</script>

<style scoped>
.footer {
  background: var(--bg-navy);
  border-top: 1px solid var(--border);
}

.footer-inner {
  max-width: 1300px;
  margin: 0 auto;
  padding: 4rem 6vw 2rem;
}

.footer-top {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.4fr;
  gap: 3rem;
  margin-bottom: 3rem;
}

/* Brand */
.footer-brand {
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.brand-logo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--gold);
  object-fit: contain;
  background: var(--bg-dark);
}

.brand-logo span {
  font-size: 1.2rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--gold-light), var(--gold));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-tagline {
  color: var(--gray);
  font-size: 0.9rem;
  line-height: 1.7;
  margin-bottom: 1.4rem;
}

.footer-socials {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.fsocial {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--gray);
  transition: all 0.3s;
}

.fsocial:hover {
  border-color: var(--gold);
  color: var(--gold);
  transform: translateY(-2px);
}

/* Cols */
.footer-col h4.col-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--gold-light);
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border);
}

.footer-col ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footer-col ul a {
  color: var(--gray);
  font-size: 0.88rem;
  transition: color 0.3s;
}

.footer-col ul a:hover {
  color: var(--gold);
}

.footer-wa {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(37, 211, 102, 0.1);
  border: 1px solid rgba(37, 211, 102, 0.3);
  color: #25d366;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  font-size: 0.88rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  transition: all 0.3s;
}

.footer-wa:hover {
  background: rgba(37, 211, 102, 0.2);
  transform: translateY(-2px);
}

.footer-email {
  display: block;
  color: var(--gray);
  font-size: 0.85rem;
  margin-bottom: 1rem;
  transition: color 0.3s;
}

.footer-email:hover {
  color: var(--gold);
}

.footer-hours {
  color: var(--gray);
  font-size: 0.82rem;
  line-height: 1.6;
}

/* Bottom */
.footer-bottom {
  border-top: 1px solid var(--border);
  padding-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-bottom p {
  color: var(--gray);
  font-size: 0.85rem;
}

.bottom-links {
  display: flex;
  gap: 1.5rem;
}
.bottom-links a {
  color: var(--gray);
  font-size: 0.85rem;
  transition: color 0.3s;
}
.bottom-links a:hover {
  color: var(--gold);
}

@media (max-width: 1000px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

@media (max-width: 600px) {
  .footer-top {
    grid-template-columns: 1fr;
  }
  .footer-inner {
    padding: 3rem 1.5rem 2rem;
  }
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
}
</style>
